import React from 'react';
import { AdminModeExitPopup } from '../../../../../../customer/components/popups/admin-mode-exit-popup';
import classes from './admin-mode-colored-frame.scss';
export const AdminModeColoredFrame = ({
  labelText,
  onExit
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.top
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.right
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.bottom
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.left
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.labelContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.labelText
  }, labelText), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonBlock
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.exitButton,
    onClick: onExit
  }, "Exit"))), /*#__PURE__*/React.createElement(AdminModeExitPopup, null));
};